export default __webpack_public_path__ + "static/media/bg-land_11zon.2174daf4.webp";